import { render, staticRenderFns } from "./PersonasByRol.vue?vue&type=template&id=1fcec439"
import script from "./PersonasByRol.vue?vue&type=script&lang=js"
export * from "./PersonasByRol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports